import React from "react";
import { useNavigate } from "react-router-dom";
import { TabMenu } from 'primereact/tabmenu';
import './HeaderVisitantes.scss';

const HeaderVisitantes = ({ seccion }) => {
    const navigate = useNavigate();

    const items = [
        {
            label: 'Entradas',
            icon: 'pi pi-sign-in',
            command: () => navigate("/administracion/registro-visitantes/entradas")
        },
        {
            label: 'Salidas',
            icon: 'pi pi-sign-out',
            command: () => navigate("/administracion/registro-visitantes/salidas")
        },
        {
            label: 'Reportes con gráfica',
            icon: 'pi pi-chart-bar',
            command: () => navigate("/administracion/registro-visitantes/graficas")
        }
    ];

    return (
        <div className="HeaderVisitantes">
            <TabMenu
                model={items}
                activeIndex={parseInt(seccion) - 1}
                className="w-full"
            />
        </div>
    );
};

export default HeaderVisitantes;
